import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { assignModelOptions, AttendeeModel, ConfigConstants, TextModel } from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-confirmation-add-attendee',
    templateUrl: './confirmation-add-attendee.component.html',
    styleUrls: ['./confirmation-add-attendee.component.scss'],
})
export class ConfirmationAddAttendeeComponent implements OnInit {
    @Input()
    public model: AttendeeModel;

    @Input()
    public edit: boolean;

    @Output()
    public modelChanged = new EventEmitter<AttendeeModel>();

    public attendeeForm: FormGroup;
    public attendeeFormChildren: FormArray;

    public displayTitleTextBox: boolean;

    public titleText: string;
    public buttonText: string;

    public constructor(
        private readonly formBuilder: FormBuilder,
        public readonly modalInstance: BsModalRef,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.titleText = this.edit
            ? <string>this.translate.instant('CONFIRMATION_ATTENDEELIST_EDIT_ATTENDEE_LABEL')
            : <string>this.translate.instant('CONFIRMATION_ATTENDEELIST_ADD_ATTENDEE_LABEL');

        this.buttonText = this.edit
            ? <string>this.translate.instant('CONFIRMATION_ATTENDEELIST_EDIT_ATTENDEE_LABEL')
            : <string>this.translate.instant('CONFIRMATION_ATTENDEELIST_ADD_ATTENDEE_LABEL');

        this.attendeeFormChildren = this.formBuilder.array([]);
        this.attendeeForm = this.formBuilder.group({
            formChildren: this.attendeeFormChildren,
        });

        const title = this.model.title.selectedEntry;

        this.displayTitleTextBox = title && title.displayName === ConfigConstants.attendeeTitleOther;
        this.setEmailAddressMandatory(this.model);
    }

    public onTitleDropDownChange(attendee: AttendeeModel): void {
        const title = attendee.title;

        // need to do a clone deep to make change detection aware of the changes
        const textTitle = _.cloneDeep(attendee.textTitle);

        // if the selectedEntry is "Other" we need to make the textTitle required
        // Otherwise the textTitle should be hidden, not required, and reset to an empty string.
        if (title.selectedEntry.displayName === ConfigConstants.attendeeTitleOther) {
            this.displayTitleTextBox = true;
        } else {
            this.displayTitleTextBox = false;
            textTitle.value = '';
        }

        attendee.textTitle = textTitle;

        // we need to trigger the change detection for the form validation to occur.
        this.changeDetectorRef.detectChanges();
    }

    public setEmailAddressMandatory(attendee: AttendeeModel): void {
        // we need to clone deep to make the change detection aware of the changes.
        attendee.mail = <TextModel>this.model.set(_.cloneDeep(attendee.mail));
        attendee.mail = assignModelOptions(
            attendee.mail,
            {
                ...attendee.mail.options,
                required: !attendee.notReceivingCredit.value,
            },
            attendee,
        );

        // we need to trigger the change detection for the form validation to occur.
        this.changeDetectorRef.detectChanges();
    }

    public save(): void {
        this.modelChanged.emit(this.model);
        this.modalInstance.hide();
    }
}
